import api from '../api';

/**
 * Resolves with the recording rows, or an empty list on failure.
 */
const list = ({ commit }, args) => {
  commit('RESET_STATE');
  commit('FETCHING', true);

  return api.list(args)
    .then((response) => {
      commit('FETCH_SUCCESS', true);
      commit('FETCHING', false);
      commit('SET_VALUES', response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      commit('FETCH_SUCCESS', false);
      commit('FETCHING', false);
      commit('FETCH_ERROR', error);
      console.error(error);
      return [];
    });
};

/**
 * A failed mint means the class cannot play,
 * and the page should handle it instead of render an empty player.
 *
 * Never cache the result.
 * @throws {Error} If the minting fails.
 */
const access = ({ commit }, args) => {
  commit('MINTING', true);

  return api.access(args)
    .then((response) => {
      commit('MINTING', false);
      commit('SET_ACCESS', response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      commit('MINTING', false);
      commit('FETCH_ERROR', error);
      throw error;
    });
};

export default {
  list,
  access,
};
